import { render, staticRenderFns } from "./search_joints.vue?vue&type=template&id=8f50e752&"
import script from "./search_joints.vue?vue&type=script&lang=js&"
export * from "./search_joints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports